// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"84abcc2e","130":"337716de","272":"11561500","603":"ff89a033","624":"c0a8beda","684":"1582fc66","769":"04006722","858":"354bf1ba","986":"5aafd83e","995":"da02c7cd"}[chunkId] + ".chunk.js";
};